"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicTextEditor = void 0;
var React = __importStar(require("react"));
var Common_1 = require("../Common");
var DynamicEditor_1 = require("./DynamicEditor");
var RichTextEditor_1 = require("./RichTextEditor");
var DynamicTextEditor = /** @class */ (function (_super) {
    __extends(DynamicTextEditor, _super);
    function DynamicTextEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicTextEditor.prototype.render = function () {
        var enableHtmlEditor = this.props.enableHtmlEditor;
        return React.createElement(React.Fragment, null, enableHtmlEditor ? this.getRichTextEditor() : this.getSimpleEditor());
    };
    DynamicTextEditor.prototype.getRichTextEditor = function () {
        var _a = this.props, inputType = _a.inputType, htmlEditorMode = _a.htmlEditorMode, minWidth = _a.minWidth, maxWidth = _a.maxWidth, width = _a.width, rest = __rest(_a, ["inputType", "htmlEditorMode", "minWidth", "maxWidth", "width"]);
        var toolbarConfiguration = this.state.toolbarConfiguration;
        return (React.createElement(RichTextEditor_1.RichTextEditor, __assign({}, rest, { inputType: inputType, width: width, minWidth: minWidth, maxWidth: maxWidth, mode: htmlEditorMode, toolbar: toolbarConfiguration, onBlur: this.onBlur, onChange: this.onEditorChange })));
    };
    // The SimpleEditor getter operates on a switch in order to force the implementation of the DTE to be more
    // specific about which input type is in use. If the input type is not specified, it displays a message.
    DynamicTextEditor.prototype.getSimpleEditor = function () {
        var _a = this.props, inputType = _a.inputType, id = _a.id, placeholder = _a.placeholder, readOnly = _a.readOnly, value = _a.value, messages = _a.messages, rest = __rest(_a, ["inputType", "id", "placeholder", "readOnly", "value", "messages"]);
        var message = this.props.messages;
        switch (inputType) {
            case 'textarea':
                return (React.createElement(Common_1.TextArea, __assign({ id: id }, rest, { className: 'tws-editable-textarea', disabled: readOnly, onChange: this.onChange, onBlur: this.onBlur, onPaste: this.onPaste, placeholder: placeholder, message: message, value: value || '' })));
            case 'input':
                return (React.createElement(Common_1.Input, __assign({ id: id, value: value || '' }, rest, { onChange: this.onChange, onBlur: this.onBlur, onPaste: this.onPaste, message: message, placeholder: placeholder, disabled: readOnly })));
            case 'typeahead':
            default:
                return React.createElement("span", null,
                    "The editable type '",
                    inputType,
                    "' is not supported in the DynamicTextEditor.");
        }
    };
    return DynamicTextEditor;
}(DynamicEditor_1.DynamicEditor));
exports.DynamicTextEditor = DynamicTextEditor;
